import React, { useEffect, useState } from 'react';
import { useContextInfo } from '../../context/ContextInfo';
import { Card, Col, Form, Modal, Row, Button, Spinner } from 'react-bootstrap';
import { useForm } from '../../hooks/useForm';
import { fetchConToken } from '../../api/fetch';
const initialState = {
    id: '',
    nombre: '',
    color: '',
};
const ModEtiqueta = ({ show, onClose, item, callBk }) => {
    const { setResp } = useContextInfo();
    const [values, handleInputChange, reset, setFormValue] = useForm({ ...initialState });

    const [load, setLoad] = useState(false);
    const [validated, setValidated] = useState(false);
    const { id } = values;
    useEffect(() => {
        !show ? setFormValue({ ...initialState }) : setFormValue({ ...values, ...item });
    }, [show]);

    const funClose = () => {
        if (id) {
            onClose();
        } else {
            reset();
            onClose();
        }
    };
    const onSubmit = async (e) => {
        const form = e.currentTarget;
        e.preventDefault();
        setLoad(true);
        if (form.checkValidity() === false) {
            setValidated(true);
        } else {
            let res = await fetchConToken(`usertools/tag`, values, 'POST');
            setResp(res);
            callBk();
            funClose();
            onClose();
        }
        setLoad(false);
    };
    return (
        <Modal show={show} onHide={funClose} size="sm">
            <Modal.Header onHide={funClose} closeButton>
                <h4 className="modal-title">{id ? 'Editar etiqueta' : 'Nueva etiqueta'}</h4>
            </Modal.Header>
            <Modal.Body>
                <Card className="p-3">
                    <Form noValidate validated={validated} onSubmit={onSubmit}>
                        <Form.Group className="mb-3" controlId="validationCustom999">
                            <Form.Label>Nombre</Form.Label>
                            <Form.Control
                                required
                                type="text"
                                placeholder="Nombre"
                                value={values.nombre}
                                maxLength={120}
                                name="nombre"
                                onChange={handleInputChange}
                            />
                            <Form.Control.Feedback>Válido</Form.Control.Feedback>
                        </Form.Group>{' '}
                        <Form.Group className="mb-3" controlId="validationCustom901">
                            <Form.Label>Color</Form.Label>
                            <Form.Control type="color" value={values.color} name="color" onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Control.Feedback>Válido</Form.Control.Feedback>{' '}
                        {load ? (
                            <Button color="primary" disabled>
                                <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                                Guardando...
                            </Button>
                        ) : (
                            <Button type="submit">Guardar</Button>
                        )}
                    </Form>
                </Card>
            </Modal.Body>
        </Modal>
    );
};

export default ModEtiqueta;
